module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-2.9d2c2ddd.svg";